import * as React from 'react';
import {
  widget,
  ChartingLibraryWidgetOptions,
  LanguageCode,
  IChartingLibraryWidget,
} from '../../charting_library/charting_library.min';
import Datafeed from '../../api/';
import Colors from '../../constants/Colors';

export interface ChartContainerProps {
  symbol: ChartingLibraryWidgetOptions['symbol'];
  interval: ChartingLibraryWidgetOptions['interval'];
  // BEWARE: no trailing slash is expected in feed URL
  // datafeedUrl: string;
  libraryPath: ChartingLibraryWidgetOptions['library_path'];
  chartsStorageUrl: ChartingLibraryWidgetOptions['charts_storage_url'];
  chartsStorageApiVersion: ChartingLibraryWidgetOptions['charts_storage_api_version'];
  clientId: ChartingLibraryWidgetOptions['client_id'];
  userId: ChartingLibraryWidgetOptions['user_id'];
  fullscreen: ChartingLibraryWidgetOptions['fullscreen'];
  autosize: ChartingLibraryWidgetOptions['autosize'];
  studiesOverrides: ChartingLibraryWidgetOptions['studies_overrides'];
  containerId: ChartingLibraryWidgetOptions['container_id'];
  theme: ChartingLibraryWidgetOptions['theme'];
  overrides: ChartingLibraryWidgetOptions['overrides'];
  toolbarBg: ChartingLibraryWidgetOptions['toolbar_bg'];
  loadingScreen: ChartingLibraryWidgetOptions['loading_screen'];
}

export interface ChartContainerState {}

function getLanguageFromURL(): LanguageCode | null {
  const regex = new RegExp('[\\?&]lang=([^&#]*)');
  const results = regex.exec(location.search);
  return results === null
    ? null
    : (decodeURIComponent(results[1].replace(/\+/g, ' ')) as LanguageCode);
}

export class TVChartContainer extends React.PureComponent<
  Partial<ChartContainerProps>,
  ChartContainerState
> {
  public static defaultProps: ChartContainerProps = {
    symbol: '',
    interval: '15',
    containerId: 'tv_chart_container',
    // datafeedUrl: 'https://demo_feed.tradingview.com',
    libraryPath: '/charting_library/',
    chartsStorageUrl: 'https://saveload.tradingview.com',
    chartsStorageApiVersion: '1.1',
    clientId: 'tradingview.com',
    userId: 'public_user_id',
    fullscreen: false,
    autosize: true,
    studiesOverrides: {},
    theme: 'Dark',
    toolbarBg: Colors.deepBlueGray,
    loadingScreen: {
      backgroundColor: Colors.deepBlack,
      foregroundColor: Colors.deepBlack,
    },
    overrides: {
      // "mainSeriesProperties.showCountdown": true,
      'paneProperties.background': Colors.deepBlack,
      'paneProperties.vertGridProperties.color': Colors.deepBlueGray,
      'paneProperties.horzGridProperties.color': Colors.deepBlueGray,
      'symbolWatermarkProperties.transparency': 90,
      'scalesProperties.textColor': '#AAA',
      'mainSeriesProperties.candleStyle.wickUpColor': '#336854',
      'mainSeriesProperties.candleStyle.wickDownColor': '#7f323f',
    },
  };

  private tvWidget: IChartingLibraryWidget | null = null;

  public componentDidMount(): void {
    const widgetOptions: ChartingLibraryWidgetOptions = {
      symbol: this.props.symbol as string,
      // BEWARE: no trailing slash is expected in feed URL
      // tslint:disable-next-line:no-any
      datafeed: Datafeed,
      // datafeed: new (window as any).Datafeeds.UDFCompatibleDatafeed(this.props.datafeedUrl),
      interval: this.props.interval as ChartingLibraryWidgetOptions['interval'],
      container_id: this.props.containerId as ChartingLibraryWidgetOptions['container_id'],
      library_path: this.props.libraryPath as string,

      locale: getLanguageFromURL() || 'en',
      disabled_features: [
        'border_around_the_chart',
        'use_localstorage_for_settings',
        'header_saveload',
        'compare_symbol',
        'header_symbol_search',
        'header_compare',
        'timezone_menu',
        'control_bar',
        // 'left_toolbar',
      ],
      enabled_features: [],
      charts_storage_url: this.props.chartsStorageUrl,
      charts_storage_api_version: this.props.chartsStorageApiVersion,
      client_id: this.props.clientId,
      user_id: this.props.userId,
      fullscreen: this.props.fullscreen,
      autosize: this.props.autosize,
      studies_overrides: this.props.studiesOverrides,
      toolbar_bg: this.props.toolbarBg,
      theme: this.props.theme,
      overrides: this.props.overrides,
      loading_screen: this.props.loadingScreen,
    };

    const tvWidget = new widget(widgetOptions);
    this.tvWidget = tvWidget;

    tvWidget.onChartReady(() => {
      tvWidget
        .chart()
        .onSymbolChanged()
        .subscribe(null, () => {
          console.log('symbol changed');
        });
      // tvWidget.changeTheme('Dark');
    });
  }

  public componentDidUpdate(
    prevProps: Partial<ChartContainerProps>,
    prevState: ChartContainerState,
  ) {
    if (this.props.symbol !== prevProps.symbol) {
      if (this.tvWidget && this.props.symbol) {
        this.tvWidget.setSymbol(this.props.symbol, '15', () => {});
      }
    }
  }

  public componentWillUnmount(): void {
    if (this.tvWidget !== null) {
      this.tvWidget.remove();
      this.tvWidget = null;
    }
  }

  public render(): JSX.Element {
    return <div id={this.props.containerId} className={'TVChartContainer'} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/TVChartContainer/TVChartContainer.tsx